import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { createUrlWithLkId, sendDispatchEvent } from '@/utils/utils';
import { sliderSettings, transformVehicleData } from './utils';
import CardVehicleRecommendationV2 from '@/components/CardVehicle/CardVehicleRecommendationV2';

const VehicleCards = ({ searchResults, vehicleType, eventName, lkIds }) => {
  return (
    <Slider {...sliderSettings}>
      {searchResults.map((vehicle, index) => {
        const dataVehicle = transformVehicleData(vehicle, vehicleType);
        const { linkCard } = dataVehicle;

        if (lkIds && lkIds[index]) {
          dataVehicle.linkCard = createUrlWithLkId(linkCard, lkIds[index]);
        }

        return (
          <div key={dataVehicle.uniqueId} className="slick-padding" onClick={() => sendDispatchEvent(eventName)}>
              <CardVehicleRecommendationV2
                refs="cardResult"
                cardId={`CardVehicleRecommendation_${dataVehicle.uniqueId}`}
                dataVehicle={dataVehicle}
              />            
          </div>
        );
      })}
    </Slider>
  );
};

VehicleCards.propTypes = {
  searchResults: PropTypes.array.isRequired,
  vehicleType: PropTypes.string.isRequired,
  eventName: PropTypes.string, 
  lkIds: PropTypes.array, 
};

VehicleCards.defaultProps = {
  eventName: '', 
  lkIds: [],
};

export default VehicleCards;
